import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";

class CreateModel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {
                name : "",
                main : "",
                description : "",
                image : "",
            },
            errors: {},
            selectedFile : '',
        };
    }

    getExtension(filename) {
        let parts = filename.split('.');
        return parts[parts.length - 1];
    }

    isImage(filename) {
        let ext = this.getExtension(filename);
        switch (ext.toLowerCase()) {
          case 'jpg':
          case 'gif':
          case 'bmp':
          case 'png':
            //etc
            return true;
        }
        return false;
    }

    fileChangedHandler = (event) => {
        const file = event.target.files[0];
        this.setState({ selectedFile: file });
    }

    handleValidation(){
        let fields = this.state.item;
        let errors = {};
        let formIsValid = true;
        let file = this.state.selectedFile;
        let FileSize = file.size / 1024 / 1024; // in MB
        let FileName = file.name;    
        let extensionLists = {}; //Create an object for all extension lists         
        extensionLists.image = ['jpg', 'gif', 'bmp', 'png'];

        if(!fields.name){
            formIsValid = false;
            errors.name = "Please name field is required.";
        }

        if(!fields.main){
            formIsValid = false;
            errors.main = "The main field is required.";
        }        

        if (file && FileSize > 2) {
            errors.image = "File size exceeds 2 MB";
        } 
        
        if (file && !this.isImage(FileName)) {
            errors.image = "Please select a valid image file.";
        }

        this.setState({errors: errors});
        return formIsValid;
    }   

    create = e => {
        e.preventDefault();
        const formData = new FormData();       
        if(this.handleValidation()){  
               
            if(this.state.selectedFile)
            {
                formData.append(
                    'icon',
                    this.state.selectedFile,
                    this.state.selectedFile.name
                )
            }
            formData.append('name',this.state.item.name);
            formData.append('main',this.state.item.main);
            formData.append('description',this.state.item.description);
            this.props
            .create(formData)
            .then(response => {
                this.props.hideCreate();
            })
            .catch(errors => {
                switch (errors.response.status) {
                    case 422:
                        this.setState({ errors: errors.response.data.error });
                        break;
                    default:
                        this.context.state.handelError(errors);
                        break;
                }
            });

            //console.log(formData.values(),this.state.item);
        }  
        
    };

    onChange(field) {
        let temp = this.state.item;
        temp[field.target.name] = field.target.value;

        let error = this.state.errors;
        error[field.target.name] = null;

        this.setState({ item: temp, errors: error });
    }

    render() {
        return (
            <div className="model-container model-center model-backdrop-show">
                <div
                    aria-labelledby="model-title"
                    aria-describedby="model-content"
                    className="model-popup model-modal model-show"
                    role="dialog"
                    aria-live="assertive"
                    aria-modal="true"
                >
                    <h2 className="mb-5">Create record</h2>
                    <div className="model-content">
                        <form onSubmit={this.create}>
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="name"
                                    name="name"
                                    placeholder="Enter name"
                                ></input>
                                {this.state.errors.name ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.name}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="main">Main</label>
                                <select
                                    onChange={this.onChange.bind(this)}
                                    type="text"
                                    className="form-control"
                                    id="main"
                                    name="main"
                                >
                                    <option>Select option</option>
                                    <option value="true">Yes</option>
                                    <option value="false">No</option>
                                </select>
                                {this.state.errors.main ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.main}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="description">Description</label>
                                <input
                                    type="text"
                                    onChange={this.onChange.bind(this)}
                                    className="form-control"
                                    placeholder="Description"
                                    name="description"
                                    rows="3"
                                ></input>
                                {this.state.errors.description ? (
                                    <div className="invalid-feedback">
                                        {this.state.errors.description}
                                    </div>
                                ) : null}
                            </div>
                            <div className="form-group">
                                <label htmlFor="image">Icon</label>
                                <input
                                            id="image"
                                            name="image"                                           
                                            onChange={this.fileChangedHandler}
                                            type="file"
                                            className="form-control"
                                        />

                                        {this.state.errors.image ? (
                                            <div className="text-danger">
                                                {this.state.errors.image}
                                            </div>
                                        ) : null}
                                
                            </div>
                            <button
                                type="button"
                                onClick={this.create}
                                className="btn btn-primary mr-2"
                            >
                                Submit
                            </button>
                            <button
                                type="button"
                                onClick={this.props.hideCreate}
                                className="btn btn-default"
                            >
                                Cancel
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}
CreateModel.contextType = AppContext;
export default CreateModel;



// WEBPACK FOOTER //
// ./src/components/admin/industries/CreateModel.js